import * as React from "react";

import { useFeatures } from "./features-provider";

export enum FEATURES_REQUIREMENT_STRICTNESS_TYPE {
  ALL = "all",
  ANY = "any",
}

export type FeaturesRequirementStrictnessType =
  `${FEATURES_REQUIREMENT_STRICTNESS_TYPE}`;

interface FeatureGuardProps {
  features: string[];
  strictness?: FeaturesRequirementStrictnessType;
}

export const FeatureGuard: React.FunctionComponent<FeatureGuardProps> = (
  props
) => {
  const features = useFeatures(props.features);

  const isEnabled = React.useMemo(() => {
    if (props.strictness === FEATURES_REQUIREMENT_STRICTNESS_TYPE.ANY) {
      return features.some((feature) => !!feature?.enabled);
    }
    // if (!props.require || props.require === FEATURES_REQUIREMENT_TYPE.ALL)
    return features.every((feature) => !!feature?.enabled);
  }, [props, features]);

  if (!isEnabled) {
    return null;
  }
  return <>{props.children}</>;
};
